import { Checkbox, Form } from 'antd';
import { styledWithTransientProps } from 'utilities/styles';

const StyledFormItem = styledWithTransientProps(Form.Item)(({ $isChecked }) => {
  let border = 'var(--color-border)';
  let backgroundColor = 'var(--color-background)';
  if ($isChecked) {
    border = 'var(--color-warning-border)';
    backgroundColor = 'var(--color-warning-background)';
  }

  return `
    margin: 0 auto;
    margin-bottom: var(--spacing-lg);
    border: ${border} 1px solid;
    border-radius: var(--border-radius);
    background-color: ${backgroundColor};
    padding: var(--spacing-xs) var(--spacing);
  `;
});

const LimitedAccessCheckbox = ({
  children,
  name,
  hasAccess,
  ...formItemProps
}) => {
  const form = Form.useFormInstance();
  const isChecked = Form.useWatch(name, form);

  return hasAccess ? (
    <StyledFormItem
      $isChecked={isChecked}
      valuePropName="checked"
      name={name}
      {...formItemProps}
    >
      <Checkbox>{children}</Checkbox>
    </StyledFormItem>
  ) : null;
};

export default LimitedAccessCheckbox;
